<script>
    import voditemContent from './VODitemContent.vue';

    export default {
        components: { voditemContent },
        emits: ['vodFavourite'],
        methods: {
            toggleVodFavourite(id) {
                this.$emit('vodFavourite', id);
            }
        },
        props: {
            item: Object,
            unavailableLabel: {
                type: String,
                default: 'Niet beschikbaar'
            },
            favouriteTitleAdd: {
                type: String,
                default: 'Voeg toe aan favorieten'
            },
            favouriteTitleRemove: {
                type: String,
                default: 'Verwijder van favorieten'
            },
            isLoggedIn: {
                type: Boolean,
                default: false
            },
            availableLabel: {
                type: String,
                default: 'Beschikbaar'
            },
            culture: {
                type: String,
                default: 'nl-NL'
            }
        }
    }
</script>

<template>
    <a :href="item.detailUrl" class="image-link" v-if="item.detailUrl && item.detailUrl !== '#'">
        <voditem-content :item="item" :favourite-title-add="favouriteTitleAdd" :favourite-title-remove="favouriteTitleRemove" :is-logged-in="isLoggedIn" :available-label="availableLabel" :unavailable-label="unavailableLabel" :is-available="true" :culture="culture" v-on:toggle-vod-favourite="toggleVodFavourite" />
    </a>
    <div class="image-link is-relative" v-else>
        <voditem-content :item="item" :is-logged-in="isLoggedIn" :favourite-title-add="favouriteTitleAdd" :favourite-title-remove="favouriteTitleRemove" :available-label="availableLabel" :unavailable-label="unavailableLabel" :is-available="false" :culture="culture" v-on:toggle-vod-favourite="toggleVodFavourite" />
    </div>
</template>
